import jwt_decode from "jwt-decode";

// Set Token
export const setToken = (token, refreshToken) => {
  const TokenKey = localStorage.setItem("vue_token", token);
  document.cookie = `accessToken=${token}; expires=Wed, 16 Jan 2030 12:00:00 UTC; path=/;domain=hire3x.com;`;
  document.cookie = `refreshToken=${refreshToken}; expires=Wed, 16 Jan 2030 12:00:00 UTC; path=/;domain=hire3x.com;`;
  return TokenKey;
};

// Remove Token
export const removeToken = () => {
  document.cookie = `accessToken=;expires=Thu, 01 Jan 1970 00:00:00 UTC;path=/;domain=hire3x.com;`;
};

// Get Token
export const getToken = () => {
  if (document.cookie.length > 0) {
    let data = document.cookie.split(";");
    for (let i in data) {
      let cur = data[i].split("=");
      if (cur[0].trim() === "accessToken") {
        return cur[1];
      }
    }
  }
  return null;
};

export const getRefreshToken = () => {
  if (document.cookie.length > 0) {
    let data = document.cookie.split(";");
    for (let i in data) {
      let cur = data[i].split("=");
      if (cur[0].trim() === "refreshToken") {
        return cur[1];
      }
    }
  }
  return null;
};


// Check for Token Expiry
export const checkTokenExpiry = () => {
  let cookieToken = getToken();
  let decoded = jwt_decode(cookieToken);
  let time = null;
  if (Date.now() >= decoded.exp * 1000) {
    time = false;
  } else {
    time = true;
  }
  return time;
};

export const checkAdminAccess = (type) => {
  if (type) return true;
  else {
    let cookieToken = getToken();
    let decoded = jwt_decode(cookieToken);
    return (decoded.realm_access.roles.includes("Hire3xAdmin"));
  }
}

export const clearCookies = () => {
  const cookies = document.cookie.split(";");
  for (let i = 0; i < cookies.length; i++) {
    const cookie = cookies[i];
    const eqPos = cookie.indexOf("=");
    const name = eqPos > -1 ? cookie.substr(0, eqPos) : cookie;
    document.cookie =
      name.trim() +
      "=;expires=Thu, 01 Jan 1970 00:00:00 UTC;path=/;domain=hire3x.com;";
    // name.trim() + "=;expires=Thu, 01 Jan 1970 00:00:00 UTC;path=/;";
  }
};

export const checkAndSetCookies = (projects) => {
  let filteredProjects = projects.filter(obj => {
    let val = obj.userPermissions ? obj.userPermissions.isActive : obj.isActive;
    if (val) return obj;
  })
  filteredProjects.map((obj) => {
    document.cookie = `${obj.project}=${JSON.stringify(obj)}; expires=Wed, 16 Jan 2030 12:00:00 UTC; path=/;domain=hire3x.com;`;
  })
}

export const getMobileToken = () => {
	if (document.cookie.length > 0) {
		let data = document.cookie.split(";");
		for (let i in data) {
			let cur = data[i].split("=");
			if (cur[0].trim() === "mobileToken") {
				return JSON.parse(cur[1]).token;
			}
		}
	}
	return null;
};
